import React, {useMemo, useState} from "react";
import {Badge} from "./Badge.jsx";
import {SortHeader, sortRows} from "./SortButton.jsx";
import {metricClass, money, signed} from "../format.js";

const initialSort = {field: "", direction: "desc"};

function valueFor(strategy, field) {
    return strategy[field] == null ? null : strategy[field];
}

export function StrategiesTable({strategies}) {
    const [sort, setSort] = useState(initialSort);
    const ordered = useMemo(() => sortRows(strategies, sort, valueFor), [sort, strategies]);
    const onSort = (field) => setSort((current) => ({
        field,
        direction: current.field === field && current.direction === "asc" ? "desc" : field === current.field ? "asc" : ["strategyRef", "lifecycle", "comparison"].includes(field) ? "asc" : "desc",
    }));

    if (!strategies.length) return <div className="empty">No strategies match this view.</div>;
    return (
        <div className="table-wrap">
            <table>
                <thead>
                    <tr>
                        <SortHeader
                            label="Strategy" field="strategyRef" sort={sort}
                            onSort={onSort}
                        />
                        <SortHeader
                            label="Placements" field="placementCount" sort={sort}
                            onSort={onSort}
                        />
                        <SortHeader
                            label="Net P&L" field="netPnl" sort={sort}
                            onSort={onSort} numeric
                        />
                        <SortHeader
                            label="Risk" field="totalRiskUsd" sort={sort}
                            onSort={onSort} numeric
                        />
                        <SortHeader
                            label="Status" field="comparison" sort={sort}
                            onSort={onSort}
                        />
                        <SortHeader
                            label="Identity" field="identityStatus" sort={sort}
                            onSort={onSort}
                        />
                    </tr>
                </thead>
                <tbody>
                    {ordered.map((strategy) => (
                        <tr key={strategy.strategyRef} className="clickable">
                            <td>
                                <a href={`#strategy/${encodeURIComponent(strategy.strategyRef)}`}>
                                    <div className="mono">{strategy.strategyRef}</div>
                                    <div className="subtle">
                                        {strategy.category}
                                        {" "}
                                        ·
                                        {" "}
                                        {strategy.side}
                                    </div>
                                </a>
                            </td>
                            <td>{strategy.placementCount}</td>
                            <td className={`num ${metricClass(strategy.netPnl)}`}>{signed(strategy.netPnl)}</td>
                            <td className="num">{money(strategy.totalRiskUsd)}</td>
                            <td><Badge value={strategy.comparison}/></td>
                            <td><Badge value={strategy.identityStatus || "UNAVAILABLE"}/></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
